export default function Personal({ details }) {
  return (
    <div className="roboto-regular">
      {details.intro && (
        <p className="pt-4 italic text-[#00adef] text-lg text-white">
          {details.intro}
        </p>
      )}

      {details.bullets && details.bullets.length > 0 && (
        <ul className="list-disc pl-6 py-3 text-white">
          {details.bullets.map((item, index) => (
            <li key={index} className="py-1 text-xl">
              {item}
            </li>
          ))}
        </ul>
      )}

      {(details.renewal || details.contactEmail) && (
        <p className="text-[#00adef] text-lg text-white">
          {details.renewal}
          {details.contactEmail && (
            <>
              {" "}
              Cancel anytime by contacting{" "}
              <a
                href={`mailto:${details.contactEmail}`}
                className="block text-[#00adef]"
              >
                {details.contactEmail}
              </a>
            </>
          )}
        </p>
      )}
    </div>
  );
}
